import {GameFont} from '../GameFont'
import {PIXI} from '@colonist/pixi'
import {uiGameManager} from '../../../shared/scripts/EntryShared'
import {ViewAnimationController} from '../ui_canvas_engine/ViewAnimationController'
import {TextView} from '../ui_canvas_engine/TextView'
import {GameColor} from '../GameColor'
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {UIGameGoToPointFadeAnimation} from '../ui_canvas_engine/animation/UIGameGoToPointFadeAnimation'
import {GameStateEnums} from '../../../../shared/GameEnums'
import {Point} from '@colonist/game-mechanic-validators'

export enum FloatingTextDirection {
    Up = -1,
    Down = 1
}

export class FloatingText extends TextView {
    private readonly animationController: ViewAnimationController
    private readonly direction: FloatingTextDirection
    private readonly valpha: number = 0.016

    constructor(text: TranslationObject, view: PIXI.Container, direction: FloatingTextDirection = FloatingTextDirection.Up) {
        const responsiveStrokeThickness = GameFont.getResponsiveSize(GameFont.Size.XL / 4)
        const textStyle: Partial<PIXI.TextStyle> = {
            fontWeight: GameFont.Weight.SemiBold,
            stroke: GameColor.getColor(GameColor.Color.PrimaryBlue6),
            strokeThickness: responsiveStrokeThickness,
        }

        super(text, 0, 0, uiGameManager.canvasController.appW, 0, uiGameManager.canvasController.app.stage, GameFont.Size.XL, GameColor.getColor(GameColor.Color.White), false, textStyle)
        this.direction = direction
        const canvas = uiGameManager.canvasController
        if(UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) {
            uiGameManager.eventController.sendEvent(text, GameStateEnums.UIGameEventEnums.FloatingNotification)
            this.destroy()
            return
        }

        const center = view.getGlobalPosition()
        this.x = center.x - this.width / 2 + view.width / 2
        this.y = direction == FloatingTextDirection.Up ? center.y - this.height / 2 : center.y + this.height / 2
        const margin = 10
        if(this.x < 0) this.x = 0 + margin

        const doesTextFlyUnderChatBox = (this.x + this.width) > (uiGameManager.canvasController.appW - uiGameManager.canvasController.chatWidth)
        if(doesTextFlyUnderChatBox) this.x = uiGameManager.canvasController.appW - uiGameManager.canvasController.chatWidth - this.width

        const destinationY = this.y + this.direction * canvas.itemSize
        const destinationPoint = new Point(this.x, destinationY)
        const textFloatingSpeed = 0.125

        const floatingTextAnimation = new UIGameGoToPointFadeAnimation(this, destinationPoint, textFloatingSpeed, {
            initialAlpha: 1,
            fadeSpeed: this.valpha,
            completionPercentageToStartFade: 0.1,
            isFadeIn: false,
        })
        floatingTextAnimation.setOnStopCallback(() => this.parent?.removeChild(this))
        floatingTextAnimation.start()
    }
}
